import { getApi, putApi } from "../api";

// Fetch user profile data (generic for both students and teachers)
export const fetchUserProfile = async (userId, userType) => {
  try {
    const response = await getApi(`/users/${userId}`);
    return response;
  } catch (error) {
    throw new Error(
      `Error fetching ${userType} profile: ${
        error.response?.data?.message || error.message
      }`
    );
  }
};

// Update user profile
export const updateUserProfile = async (userId, profileData) => {
  try {
    const response = await putApi(`/users/${userId}`, profileData);
    return response;
  } catch (error) {
    throw new Error(
      `Error updating user profile: ${
        error.response?.data?.message || error.message
      }`
    );
  }
};

// Upload profile image
export const uploadProfileImage = async (userId, file) => {
  try {
    const formData = new FormData();
    formData.append("profilePic", file);
    const response = await putApi(`/users/${userId}`, formData);
    return response;
  } catch (error) {
    throw new Error(
      `Error uploading profile image: ${
        error.response?.data?.message || error.message
      }`
    );
  }
};
